import { render, staticRenderFns } from "./ModalControles.vue?vue&type=template&id=0a6aecee"
import script from "./ModalControles.vue?vue&type=script&lang=js"
export * from "./ModalControles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports